export default {
    '广园汇汽配港登录': 'GYH APPort Login',
    '登录名/手机号/电子邮箱': 'Account Name/Phone/Email',
    '密码': 'Password',
    '记住账号': 'Remember it',
    '找回密码': 'Forgot password',
    '登录': 'Login',
    '没有账号,立即注册': 'Register',
    '快速注册': 'GYH APPort Register',
    '手机号': 'Mobile/Email',
    '短信验证码': 'Verification Code ',
    '发送验证码': 'Send Code',
    '验证码': 'Verification Code',
    '联系人': 'Customer Name',
    '公司名称': 'Company Name',
    '我已阅读并同意': 'I agree with',
    '《用户协议》': '《Membership Agreement》',
    '《隐私政策》': '《Privacy Policy》',
    ',并授权使用该账': ', and authorize Dongguan Auto Parts Port of',
    '号信息（如昵称、头像、收货地址）进行管理。': 'GYH Auto Parts Platform to use and manage my account information (such as nick name, head thumnail, address, etc.）。',
    '注册': 'Register',
    '已有账号,立即登录': 'Login',
    '再次发送': 'Send again',
    '秒': 'S',
    '新密码': 'New password',
    '修改密码': 'Change password',
    '首页': 'Home',
    '展会概况': 'Exhibition Info',
    '查看详情': 'Check Details',
    '活动介绍': 'Activity Intro',
    '展会新闻': 'Exhibition Headlines',
    '更多': 'More',
    '资讯': 'News',
    '视频': 'Video News',
    '热门资讯': 'Hot News',
    '热门视频': 'Hot Movies',
    '视频头条': 'Movie Headlines',
    '所在地区': 'Location',
    '企业类型': 'Corporation Types',
    '车系': 'Car Series',
    '品牌': 'Brands',
    '企业名称': 'Corporation Name',
    '配件分类一': 'Parts Category I',
    '配件分类二': 'Parts Category II',
    '配件品牌': 'Part Brand',
    '商品名称': 'Product Name',
    '查询': 'Search',
    '重置': 'Reset',
    '商品图片': 'Product Images',
    '商品名称': 'Product Name',
    '商品编码': 'Product No',
    '供应商': 'Supplier',
    '指导价': 'Recommended Price',
    '操作': 'Operation',
    '暂无数据': 'No data',
    '最小包装数量': 'MPQ',
    '品质': 'Quality',
    '数量': 'Quality',
    '立即询价': 'Inquiry NOW',
    '联系客服': 'Contact Customer Service',
    '发布商机': 'Publish Business Opportunities',
    '规格参数': 'Specifications',
    '商品类别': 'Product Catagory',
    '适用车型': 'Car Make',
    '是否钉箱': 'Packing',
    '每车适用数量': 'Unit',
    '重量': 'Weight',
    '尺寸': 'Single Package Size',
    '汽配嘉年华': 'Auto Parts Fair',
    '汽配港头条': 'Headlines',
    '企业库': 'Company Database',
    '产品库': 'Product Repository',
    '撮合商机': 'Business Opportunities',
    '关于我们': 'About US',
    '联系人姓名': 'Contact',
    '称谓': 'Address',
    '先生': 'Mr',
    '女士': 'Miss',
    '职务': 'Position',
    '公司类型': 'Company Type',
    '手机': 'Mobile',
    'E-mail': 'E-mail',
    '电话': 'Tel',
    '网址': 'Homepage',
    '感兴趣的展区': 'Interested Exhibition Zone',
    '工厂零部件专区。': 'Factory Brand',
    '车型品牌配件专区。': 'Integration Brands',
    '新能源配件展区。': 'EV/New Energy Exibition Zone',
    '汽车后市场数字化专区。': 'Post-market Digital Technology Companies',
    '提交申请': 'Application',
    '参加人数': 'Attended People',
    '活动时间': 'Activity Schedule',
    '人': 'People',
    '观众登记': 'Visitor Registration',
    '展商登记': 'Exibitor Registration',
    '注册类型': 'Registration Type',
    '联系电话': 'Contact Tel',
    '姓名': 'Your Name',
    '产品品类': 'Product Category',
    '工厂': 'Factory',
    '汽配品牌商': 'Brands',
    '维修厂/连锁': 'Workshop/Workshop Chains',
    '其他': 'Other',
    '欢迎来到广园汇汽配港!': 'Welcome to GuangYuanHui Auto Part Port',
    '退出登录': 'Quit',
    '免费注册': 'Free Registration',
    '新闻': 'News',
    '扫一扫关注官方公众号和小程序': 'Scan Barcode of Tencent Public Company Account and Mini-app',
    '实力工厂': 'Certified Factory',
    '查看更多': 'More',
    '优秀品牌': 'One-stop Brands',
    '优秀产品': 'Top Products',
    '搜索': 'Search',
    '请输入商品名称': 'Please input product keyword',
    '请输入公司名称': 'Please input company keyword',
    '商品': 'Product',
    '公司': 'Company',
    '购物车': 'Shopping Cart',
    '去购物车结算': 'Checkout',
    '共': 'Total',
    '件商品': 'Unit',
    '注册资金': 'Registered capital',
    '成立时间': 'Incorporation Date',
    '主营产品': 'Main Products',
    '配套客户': 'Main OEM Customers',
    '企业信息': 'Enterprise information',
    '主营品类': 'Main Product categories',
    '主营车型': 'Main Vehicle Models',
    '认证专利': 'Certified Patents',
    '库存': 'Inventory',
    '立即抢购': 'Buy now',
    '暂无商品': 'Out of stock ',
    '广': '广',
    '汇': '汇',
    '保': '保',
    '销': '销',
    '汽配展贸': 'Auto Parts Exhibition and Trade',
    '实力工厂': 'Competitive Factory',
    '品质保证': 'Quality Guarantee',
    '汽配出海': 'Auto Parts Export',
    '账号管理': 'Account Management',
    '账户注册': 'Account Registration',
    '信息维护': 'Information Maintenance',
    '安全隐私': 'Information Security and Privacy',
    '采购指南': 'Procurement Guide',
    '平台简介': 'Platform Introduction',
    '采购流程': 'Procurement Process',
    '物流配送': 'Logistics',
    '配送方式': 'Delivery Channels',
    '售后服务': 'Post-sales Service',
    '售后政策': 'Post-sales policy',
    '退货流程及规则': 'Return Process and Rules',
    '联系我们': 'Contact Us',
    '关于广园汇': 'About Us',
    '联系方式': 'Contact Info',
    '东莞广园汇供应链有限公司': 'Dongguan GuangYuanHui Supplychain Ltm.',
    '粤ICP备2024268269号-1': '粤ICP备2024268269号-1',
    '我的': 'My',
    '帮助中心': 'Support Center',
    '发布RFQ': 'Publish a RFQ',
    '该功能尚未开通，敬请期待!': 'This feature has not been activated yet, please stay tuned!',
    '底盘系列': 'Chassis Series ',
    '汽车养护系列': 'Auto Care Series ',
    '发动机': 'Auto Engine/Transmission Series ',
    '车身系列': 'Auto Body Series ',
    '展商入口': 'Exhibitor Entrance',
    '观众入口': 'Audience Entrance',
    '商机管理': 'RFQ Mgmt',
    '我的商机': 'My RFQ',
    '产品管理': 'Product Mgmt',
    '我的产品': 'My Inventory',
    '参展管理': 'Exibition Mgmt',
    '我的展位': 'My Exhibition',
    '我的收藏': 'My Favor',
    '关注工厂': 'Followed Factory',
    '关注产品': 'Followed Products',
    '个人中心': 'My',
    '企业信息': 'Company Info',
    '编码/名称': 'OE/Name',
    '类别': 'Category',
    '上传': 'Upload',
    '未审核': 'Not Reviewed',
    '审核通过': 'Approved',
    '审核不通过': 'Not Approved',
    '未知状态': 'Unknown',
    '状态': 'Status',
    '参考价格': 'Reference Price',
    '下架': 'Off Shelf',
    '上架': 'On Shelf',
    '删除': 'Delete',
    '库存模板': 'Inventory Template',
    '参展活动': 'Exibitions',
    '我要参展': 'Become Exibitor',
    '届次': 'Exbition Sessions',
    '活动名称': 'Exibition Subject',
    '活动时间': 'Exibition Schedule',
    '参展状态': 'Status',
    '未参展': 'Not Paticipated',
    '身份': 'Exibition Type',
    '展位': 'Exibition Position',
    '是否退出登录?': 'Do you want to log out?',
    '确定': 'OK',
    '取消': 'Cancel',
    '提示': 'Tips',
    '退出登录成功!': 'Log out successfully!',
    '广园汇': 'GYH',
    '汽配港': 'Parts Port',
    // 购物车
    '全部配件': 'All Products',
    '可询价': 'Inquiryable',
    '可采购': 'Available',
    '商品信息': 'Product Info',
    '单价': 'Price',
    '小计': 'SubTotal',
    '操作': 'Operation',
    '随便逛逛': ' Stroll around',
    '批量删除': 'Bulk Delete',
    '下单结算': ' Order and Checkout',
    '请输入内容': 'Please enter content',
    '请输入商机标题': 'Please enter opportunity title',
    '请输入发布人': 'Please enter the publisher',
    '请输入手机号码': 'Please enter mobile number',
    '请输入有效的手机号码': 'Please enter a valid mobile number',
    '请输入公司名称': 'Please enter company name',
    '新增商机成功': 'Opportunity added successfully',
    '新增商机失败': 'Failed to add opportunity',
    '请检查输入项！': 'Please check the input fields!',
    '上传失败': 'Upload failed',
    '删除成功': 'Deletion Successful',
    '确认删除吗?': 'Are you sure you want to delete?',
    '确认': 'Confirm',

    //    企业指数
    '个人信息认证': 'Personal Information Authentication',
    '微信认证': 'WeChat Authentication',
    '企业邮箱认证': 'Corporate Email Authentication',
    '实名认证': 'Real Name Authentication',
    '手机号码认证': 'Mobile Number Authentication',
    '企业信息认证': 'Company Information Authentication',
    '营业执照认证': 'Business License Authentication',
    '品牌商标认证': 'Brand Trademark Authentication',
    '企业门头': 'Company Facade',
    '实地认证': 'On-site Authentication',
    '高级认证': 'Advanced Authentication',
    'IS09001认证': 'ISO 9001 Certification',
    'IATF16949认证': 'IATF 16949 Certification',
    '配套资质认证': 'Supporting Qualification Certification',
    '供应商认证': 'Supplier Certification',
    '服务能力认证': 'Service Capability Certification',
    '汽配港参展企业': 'Exhibiting Company at Auto Parts Port',
    '产品目录认证': 'Product Catalog Certification',
    '汽配港入仓认证': 'Auto Parts Port Warehouse Certification',
    '进出口资质认证': 'Import and Export Qualification Certification',
    '平台能力': 'Platform Capability',
    '活跃企业': 'Active Enterprises',
    '及时响应': 'Timely Response',
    '官方品牌代理授权': 'Official Brand Authorization',
    '现货仓储认证': 'Stock Storage Certification',
    '外贸能力': 'Foreign Trade Capability',
    '外贸经营企业': 'Foreign Trade Operating Enterprises',
    '平台服务(经营eBay、亚马逊等)': 'Platform Services (Operating eBay, Amazon, etc.)',
    '海外仓': 'Overseas Warehouse',
    '出口资质认证': 'Export Qualification Certification',
    '企业指数': 'Enterprise Index',
    '更新': 'Update',
    '个人': 'Individual',
    '企业': 'Company',
    '服务': 'Service',
    '认证': 'Certification',
    '数字化': 'Digitalization',
    '超过全国': 'Surpassing',
    '%同行企业': '% of Peers Nationwide',
    //    企业指数
    '个人信息认证': '',
    // 发布商机
    '商机标题': 'Subject of Business Opportunity',
    '请简短描述您的商机主题': 'Please briefly describe of your procument requirement or business opportunity',
    '商机类型': 'Type of Requirements',
    '其他商机类型：': 'Other Requirment Types',
    '请简短描述您的商机类型': 'Please briefly describe the type of your requirement',
    '产品分类': 'Product Category',
    '所有': 'All',
    '商机产品': 'REquired/Supply Products',
    '您的商机主要针对的产品': 'Targeted Products',
    '请输入您的商机主要针对的产品': 'Please enter targeted products',
    '发布人': 'Publisher',
    '请输入您的名字': 'Please enter your name',
    '发布人手机号': 'Mobile Phone',
    '请输入您的手机号': 'Please enter your mobile phone number',
    '发布人公司': 'Your Company',
    '附加材料': 'attachments',
    '选取文件': 'Select a file',
    '支持上传图片或文件': 'File or Image',
    '发布': 'Publish',
    '供应': 'Supply',
    '需求': 'Required',
    '合作': 'Corporation',
    '招商': 'Invitation',
    '其他': 'Others',
    '热门产品': 'Pop Products',
    '项目分类': 'Project Category',
    '搜项目': 'Search Project',
    '您还可以选择': 'You can also choose',
    '最新采购项目': 'New Procurements',
    '热门采购项目': 'Pop Procurements',
    '近期采购': 'Recent Procurements',
    '发动机系列': 'Auto Engine Series',
    '加入购物车': 'Add To Cart',
    '企业指数': 'Enterprise Index',
    '加入购物车成功!': 'Successfully Added To Shopping Cart!',
    '外资独资': 'WOFE',
    '共 {total_count} 件商品，': 'Total {total_count} items, ',
    "共 {total_count} 件商品，已选择 {choose_count} 件，商品合计": "Total {total_count} items, {choose_count} selected, total amount:",
    '没有更多了': 'No More',
    '企业': 'Enterprise',
    '服务': 'Service',
    '认证': 'Certification',
    '数字化': 'Digitalization',
    '外贸': 'Foreign Trade',
    '未知': 'unKnown',
    '手机号认证': 'Mobile Number Authentication',
    '注册成功': 'Registered Successfully',
    '足迹': 'Footprint',
    '上架成功': 'Successfully put on shelf',
    '下架成功': 'Successfully removed from shelf',
    '空': 'empty'
}